import React from 'react';
import LineChart from './LineChart';
import BarChart from './BarChart';
import PieChart from './PieChart';
import './Charts.css';

const AcademyAnalytics = ({ data = {} }) => {
  const {
    resourceDownloads = [{ timestamp: new Date(), value: 0 }],
    popularResources = [],
    resourcesByCategory = [
      { category: 'Fiscal Sponsorship', downloads: 0, percentage: 0 },
      { category: 'Compliance', downloads: 0, percentage: 0 },
      { category: 'Operations', downloads: 0, percentage: 0 },
      { category: 'Fundraising', downloads: 0, percentage: 0 }
    ],
    readingStats = {
      averageReadTime: '0m',
      completionRate: '0%',
      totalDownloads: 0
    }
  } = data;

  return (
    <div className="academy-analytics">
      <h2>Academy Resource Analytics</h2>
      <div className="charts-grid">
        <div className="chart-container">
          <h3>Resource Downloads Over Time</h3>
          <LineChart 
            data={resourceDownloads}
            xAxis="Date"
            yAxis="Downloads"
          />
        </div>

        <div className="chart-container">
          <h3>Most Popular Resources</h3>
          <BarChart 
            data={popularResources.map(resource => ({
              x: resource.title,
              y: resource.downloads
            }))}
            xAxis="Resource"
            yAxis="Downloads"
          />
        </div>

        <div className="chart-container">
          <h3>Downloads by Category</h3>
          <PieChart 
            data={resourcesByCategory.map(cat => ({
              label: cat.category,
              value: cat.downloads,
              percentage: cat.percentage
            }))}
          />
        </div>

        <div className="metrics-overview">
          <div className="metric-card">
            <h4>Total Downloads</h4>
            <p>{readingStats.totalDownloads}</p>
          </div>
          <div className="metric-card">
            <h4>Avg. Read Time</h4>
            <p>{readingStats.averageReadTime}</p>
          </div>
          <div className="metric-card">
            <h4>Completion Rate</h4>
            <p>{readingStats.completionRate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademyAnalytics; 